import { getShelfQuaternion } from '@components/storeMap/floor/3d/util'
import { buildLayerGeometry, quaternionToRotationMatrix, type LayerWithGeometry } from '@utils/geometry.ts'

import type { TransformedLayoutResponse } from '@state/layout/types'

/**
 * Builds a map of globalized layers with their 3D geometry.
 *
 * Takes transformed layout shelves and calculates the global 3D coordinates
 * and geometry for each layer.
 *
 * Type flow: TransformedLayoutResponse → Map<layerId, LayerWithGeometry>
 *
 * @param layout - The transformed layout with geometrically transformed shelves
 * @returns Map of layer IDs to their geometry data
 */
export function applyLayerGeometryTransformation(
  layout: TransformedLayoutResponse
): Map<string, LayerWithGeometry> {
  const layerGeometries = new Map<string, LayerWithGeometry>()

  for (const shelf of layout.shelves) {
    const rotationMatrix = quaternionToRotationMatrix(shelf.rotation)
    const quaternion = getShelfQuaternion(shelf.rotation)

    for (const layer of shelf.layers) {
      layerGeometries.set(layer.id, buildLayerGeometry({
        shelf,
        layer,
        rotationMatrix,
        quaternion,
      }))
    }
  }

  return layerGeometries
}

